import CustomInput from 'components/shared/forms/CustomInput';
import { Button, Form } from 'reactstrap';

const RequestChangesRejectionNote = ({ onSubmit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(e.target.getObjectData().rejectionNote !== '' ? e.target.getObjectData() : undefined);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CustomInput type="textarea" label="Nota" name="rejectionNote" placeholder="Inserisci una nota" />
      <Button color="primary">
        <i className="fa fa-save" /> Salva
      </Button>
    </Form>
  );
};

export default RequestChangesRejectionNote;